'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const SendIcon = createIcon({
    displayName: 'SendIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M6.734 8.6H3.067m-.056.194l-1.557 4.65c-.122.365-.183.548-.14.66.039.098.12.172.221.2.117.033.292-.046.644-.204l11.14-5.014c.343-.154.515-.231.568-.338a.334.334 0 000-.296c-.053-.107-.225-.184-.568-.339L2.175 3.098c-.35-.157-.526-.236-.642-.204a.333.333 0 00-.22.2c-.045.112.016.294.137.659L3.01 8.457c.02.062.031.094.035.126a.333.333 0 010 .085.703.703 0 01-.035.126z"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default SendIcon
